import React, { useState } from "react";
import GiftCard from "./GiftCard";

// On-screen card with a Front / Back switch. Takes the GiftCard props.
export default function GiftCardFlip(props) {
  const [side, setSide] = useState("front");

  return (
    <div className="vs-flip">
      <div className="vs-flip-tabs no-print" role="tablist" aria-label="Card side">
        {["front", "back"].map((item) => (
          <button
            key={item}
            type="button"
            role="tab"
            aria-selected={side === item}
            className={side === item ? "is-current" : ""}
            onClick={() => setSide(item)}
          >
            {item === "front" ? "Front" : "Back"}
          </button>
        ))}
      </div>
      <GiftCard {...props} side={side} />
    </div>
  );
}
